import styled from 'styled-components'
import SMBContainer from '@components/Container'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'

export const Main = styled.footer`
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: var(--vila-olimpia-70);
`

export const Box = styled.section`
  @media (min-width: ${getBreakpoint('xl')}px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const Container = styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    max-width: 479px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Links = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  width: auto;

  @media (min-width: ${getBreakpoint('xl')}px) {
    order: 2;
    margin: 0;
    height: auto;
    flex-direction: row;
  }
`

export const LinkItem = styled.a`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-decoration: none;
  color: #f5f5fa;
  margin-top: 16px;

  &:link,
  &:visited {
    text-decoration: none;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 0;
    margin-left: 40px;
  }
`

export const Social = styled.section`
  display: flex;
  justify-content: space-between;
  width: 112px;
  margin-top: 48px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 0;
    order: 3;
    margin-left: 56px;
  }
`

export const SocialIcon = styled(Image)`
  width: 24px;
  height: 24px;
`

export const Logos = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 48px;
  width: auto;

  img:last-of-type {
    margin-top: 16px;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 0;
    order: 1;
    flex: 1;
    align-items: flex-start;
  }
`

export const Rights = styled.section`
  padding-top: 40px;
  padding-bottom: 24px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`

export const ReCaptchaRights = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  color: #9898a6;
  margin: 0;

  a {
    font-weight: 600;
    text-decoration: none;
    color: #9898a6;
  }
`

export const GympassRights = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  color: #9898a6;
  margin: 40px 0 0;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 0;
  }
`
